module.exports = __webpack_public_path__ + "img/word-cloud-dark-01.6ca04c28.jpg";